import { MapContainer } from 'react-leaflet'
import DestinationsMap from './DestinationsMap'
import { useMemo } from 'react'
import { latLngBounds } from 'leaflet'

export default function DiveResortMap({
  shopPin,
  mapData,
  shopTitle,
  countryCode,
}) {
  const initBounds = useMemo(() => {
    const bounds = latLngBounds()
    if(mapData && mapData.length) {
      mapData.forEach(({ latitude, longitude }) => {
        bounds.extend([latitude, longitude])
      })
    }
    if(shopPin && shopPin.lat && shopPin.lng) {
      bounds.extend([shopPin.lat, shopPin.lng])
    }
    return bounds
  }, [shopPin, mapData])

  return (
    <MapContainer
      bounds={initBounds}
      style={{ height: '100%' }}
      maxZoom={18}
      scrollWheelZoom={false}
      zoomControl={false}
    >
      <DestinationsMap
        countryCode={countryCode}
        shopPin={shopPin}
        pins={mapData}
        shopTitle={shopTitle}
      />
    </MapContainer>
  )
}
